import classes from "../Kiosk_viennaPlzen_redesign.module.css";
import back from "../../../../store/Vienna_new/65506-200.png";
import room
    from "../../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Big Meeting Space - Classroom - 1550191.jpg";
import suproom
    from "../../../../store/angelo_meeting.png";
import {React, useEffect, useState} from "react";
import Record from "./Record";
import ExploreRecord from "./ExploreRecord";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";

const ExploreVienna = (props) => {

    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [cards, setCards] = useState([])
    const [group, setGroup] = useState(20)
    const [data, setData] = useState([])

    const setObje = (x) => {
        let fld = []
        for (let i = 0; i < x.length; i++) {
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: assetsBaseUrl + x[i].path
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }

    const fetchDataCards = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C&group=${gr}&onlyVisible=1`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            props.reset();
        }, 2* 60* 1000); // spustí se po 10 vteřinách

        return () => {
            clearTimeout(timer); // vyčisti timeout při unmountu
        };
    }, []);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % cards.length);
        }, 15000);
        return () => {
            clearInterval(intervalId);
        };
    }, [cards]);

    const fetch_explore = async () => {
        setData([])
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
        try {
            const response = await axios.get(`${path}/getExplore`);
            setData(response.data)
        } catch (error) {
            console.log(error)

        }

    }

    useEffect(() => {
        //console.warn("ajojda")
        fetchDataCards(20)
        fetch_explore()
    }, [])

    return<> <div className={classes.slideshowMenu}>
        <div className={classes.menuBackbt} onClick={()=>{props.setStep(0)}}>
            <img src={back}/>
        </div>
        <div className={classes.menuLine}>
            <div
                className={`${classes.buttonCirc} ${classes.sleepBTsubmenu} `} onClick={()=>{props.setStep(1)}}>Sleep
            </div>
            <div
                className={`${classes.buttonCirc} ${classes.eatBTsubmenu} `} onClick={()=>{props.setStep(2)}}>Eat
            </div>
            <div
                className={`${classes.buttonCirc} ${classes.meetBTsubmenu} `} onClick={()=>{props.setStep(3)}}>Meet
            </div>
            <div
                className={`${classes.buttonCirc} ${classes.exploreBTsubmenu} ${classes.activebt}`}>Explore
            </div>
        </div>
        {cards.length > 0 && <img src={cards[currentIndexA].Body.imgURL}/>}
        {cards.length == 0 && <img src={room}/>}

    </div>
        <div className={classes.expBody}>
            {data.length >=1 && data.map((x)=>{
                return <ExploreRecord key={x.id} data={x} />
            })}
        </div>
    </>
}
export default ExploreVienna;